module.exports = __webpack_public_path__ + "img/notifications.bf1305e2.svg";